// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Utils-module--cds--assistive-text--c222e";
export var cdsHideFeedback = "Utils-module--cds--hide-feedback--bad3e";
export var cdsShowFeedback = "Utils-module--cds--show-feedback--93875";
export var cdsSkeleton = "Utils-module--cds--skeleton--c45bc";
export var cdsVisuallyHidden = "Utils-module--cds--visually-hidden--8ad4c";
export var container = "Utils-module--container--b208d";
export var hidden = "Utils-module--hidden--c9099";